// Enum representing the status of a day/week in selector for recurring events.
export enum DayWeekState {
  default = "unselected",
  selected = "selected",
  disabled = "disabled",
  autoSelected = "auto-selected",
  forceSelected = "force-selected"
}
